// extracted by mini-css-extract-plugin
export default {"title":"AlertPopup_title__kp2pw","subTitle":"AlertPopup_subTitle__pJ8mp","button":"AlertPopup_button__mFl9w"};